import { useEffect } from 'react';

interface ImagePreloaderProps {
  images: string[];
  priority?: boolean;
}

const useImagePreloader = ({ images, priority = false }: ImagePreloaderProps) => {
  useEffect(() => {
    if (priority) {
      // Preload critical images immediately
      images.forEach((src) => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        document.head.appendChild(link);
      });
    } else {
      // Preload non-critical images after a delay
      const timer = setTimeout(() => {
        images.forEach((src) => {
          const img = new Image();
          img.src = src;
        });
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [images, priority]);
};

export default useImagePreloader;